module.exports = __webpack_public_path__ + "static/img/share2.f66dfa68.svg";